import type { DictationLexicon } from '../types';

interface DictationLexiconToggleProps {
  value: DictationLexicon;
  onChange: (next: DictationLexicon) => void;
  compact?: boolean;
}

export default function DictationLexiconToggle({
  value,
  onChange,
  compact = false,
}: DictationLexiconToggleProps) {
  return (
    <section className={compact ? 'space-y-1' : 'surface p-5'}>
      {!compact && <p className="label">Orddiktat · sprog</p>}
      {!compact && (
        <p className="mt-2 text-sm text-muted">
          Vælg dansk eller engelsk til ekstraøvelsen Orddiktat.
        </p>
      )}
      <div
        className={`flex gap-2 ${compact ? '' : 'mt-3'}`}
        role="group"
        aria-label="Orddiktat · sprog"
      >
        {(['da', 'en'] as const).map((lexicon) => {
          const active = value === lexicon;
          return (
            <button
              key={lexicon}
              type="button"
              onClick={() => onChange(lexicon)}
              aria-pressed={active}
              className={`flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold transition ${
                active
                  ? 'bg-indigo-500 text-white shadow-sm dark:shadow-indigo-500/30'
                  : 'btn-secondary'
              }`}
            >
              {lexicon === 'en' ? 'Engelsk' : 'Dansk'}
            </button>
          );
        })}
      </div>
    </section>
  );
}

